import type { ReactNode } from 'react';
import styles from './WidgetBoard.module.css';

export interface WidgetSectionProps {
  /** The small word over the title: Right now, Cases, Money. */
  label: string;
  title: string;
  /** An id for the title, for a widget that is a region named by it. */
  titleId?: string;
  /** One line under the heading on what the widget shows. */
  hint?: string;
  /** What the end of the heading offers: View all, Open reports. */
  action?: ReactNode;
  children: ReactNode;
}

/**
 * A widget with its heading: the small word, the title, a hint, and what the
 * end of the heading offers. The heading every section of the Overview has
 * always had, so a widget reads the same on either screen.
 */
export function WidgetSection({ label, title, titleId, hint, action, children }: WidgetSectionProps) {
  return (
    <>
      <div className={styles.section}>
        <span className={styles.lbl}>{label}</span>
        <h3 id={titleId}>{title}</h3>
        {hint !== undefined && <span className={styles.hint}>{hint}</span>}
        <span className={styles.spacer} />
        {/* One group, so what the heading offers stays together where the heading wraps. */}
        {action !== undefined && <span className={styles.actions}>{action}</span>}
      </div>
      {children}
    </>
  );
}
